import React from 'react';
import { SvgIcon } from '@material-ui/core';

const FileIconImage = props => {
  return(
    <SvgIcon viewBox="0 0 250 250" {...props}>
      <g id="image-file-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect id="Rectangle" stroke="#264F73" strokeWidth="7" fill="#FFFFFF" x="6" y="47" width="239" height="155"></rect>
        <polygon id="Path-7" fill="#264F73" points="16 189 16 171.929688 73.3061224 123.328859 96.8163265 148.194631 163.673469 94 232 148.179688 232 189"></polygon>
        <circle id="Oval" fill="#264F73" cx="36" cy="77" r="15"></circle>
      </g>
    </SvgIcon>
  );
};

export default FileIconImage;
